import Vue from 'vue';
import Router from 'vue-router';
import IpoPage from '@/components/IpoPage'; // 首页
import getHeader from '@/components/getHeader'; // 换头像页


Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'IpoPage',
      component: IpoPage,
      meta: {
        title: '风华正茂 扬帆起航'
      }
    },{
      path: '/getHeader',
      name: 'getHeader',
      component: getHeader,
      meta: {
        title: '周年庆头像换换换'
      }
    }
  ],
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
})
export default router
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js